import {version} from '../package.json';

let componentRegistry = {};
const stats = {
	constructedByTagName: {},
	definedTagNames: [],
	deferredByTagName: {}
};

export const defineRegistry = registry => {
	componentRegistry = registry;
	stats.constructedByTagName = {};
	stats.definedTagNames = [];
	stats.deferredByTagName = {};
};

export const get = () => {
	const countByTagName = {};
	for (const k in componentRegistry) {
		const tagName = componentRegistry[k].tagName.toLowerCase();
		if (!countByTagName[tagName]) countByTagName[tagName] = 0;

		countByTagName[tagName]++; // eslint-disable-line no-plusplus
	}

	let totalConstructed = 0;
	for (const k in stats.constructedByTagName) {
		totalConstructed += stats.constructedByTagName[k];
	}

	const unusedTagNames = [];
	for (let i = 0; i < stats.definedTagNames.length; i++) {
		const tagName = stats.definedTagNames[i];
		if (!stats.constructedByTagName[tagName]) {
			unusedTagNames.push(tagName);
		}
	}

	return {
		version,
		definitions: {
			total: stats.definedTagNames.length,
			unusedTagNames,
			tagNames: [...stats.definedTagNames]
		},
		constructed: {
			total: totalConstructed,
			countByTagName: stats.constructedByTagName
		},
		connected: {
			total: Object.keys(componentRegistry).length,
			countByTagName,
			deferredByTagName: stats.deferredByTagName,
			nodes: {...componentRegistry}
		}
	};
};

export const set = (statName, tagName) => {
	switch (statName) {
		case 'constructed':
			stats.constructedByTagName[tagName] = stats.constructedByTagName[tagName] || 0;
			stats.constructedByTagName[tagName]++; // eslint-disable-line no-plusplus
			break;
		case 'defined':
			stats.definedTagNames.push(tagName);
			break;
		case 'defer':
			stats.deferredByTagName[tagName] = stats.deferredByTagName[tagName] || 0;
			stats.deferredByTagName[tagName]++; // eslint-disable-line no-plusplus
			break;
		case 'undefer':
			stats.deferredByTagName[tagName] = stats.deferredByTagName[tagName] || 0;
			if (stats.deferredByTagName[tagName]) stats.deferredByTagName[tagName]--; // eslint-disable-line no-plusplus
			break;
	}
};
